<template>
  <div class="product-center-container" style="margin-top: 90px;">
    <!-- 电脑端布局 -->
    <div class="pc-layout" v-if="!isMobile">
      <el-row :gutter="30">
        <el-col :span="8">
          <div class="product-list">
            <h3 class="list-title">案例分类</h3>
            <el-scrollbar class="scrollbar">
              <el-menu
                  :default-active="activeProduct"
                  class="product-menu"
              >
                <el-menu-item
                    class="product-item"
                    :index="'all'"
                    @click="getListAll"
                >
                  <template #title>
                    <div class="menu-item-content">
                      <span class="product-name">全部案例</span>
                    </div>
                  </template>
                </el-menu-item>
                <el-menu-item
                    v-for="product in leftProducts"
                    :key="product.id"
                    :index="product.id"
                    class="product-item"
                    @click="handleProductSelect(product.id)"
                >
                  <template #title>
                    <div class="menu-item-content">
                      <span class="product-name">{{ product.name }}</span>
                    </div>
                  </template>
                </el-menu-item>
              </el-menu>
            </el-scrollbar>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="products-display">
            <h2 class="section-title">{{ currentProductNameA || '全部案例' }} 相关案例</h2>
            <div v-if="loading" class="loading-container">
              <el-skeleton :rows="4" animated />
            </div>
            <el-row v-else :gutter="20">
              <el-col
                  v-for="product in paginatedProducts"
                  :key="product.id"
                  :span="12"
                  class="product-col"
              >
                <div class="product-card">
                  <el-image
                      class="product-image"
                      :src="getFirstImage(product.imgUrl)"
                      fit="cover"
                      :alt="product.name"
                  ></el-image>
                  <h3 class="product-name">{{ product.name }}</h3>
                  <el-button
                      type="primary"
                      class="learn-more-btn"
                      @click="goToProductDetail(product.id)"
                  >
                    了解更多
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <!-- 无数据提示 -->
            <div v-if="!loading && paginatedProducts.length === 0" class="no-data">
              暂无相关案例
            </div>

            <!-- PC端分页组件 -->
            <el-pagination
                v-if="totalProducts > pageSize"
                class="pagination"
                @current-change="handlePageChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :pager-count="7"
                layout="prev, pager, next, jumper"
                :total="totalProducts"
                prev-text="上一页"
                next-text="下一页"
                :hide-on-single-page="true">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 手机端布局 -->
    <div class="mobile-layout" v-else>
      <div class="mobile-product-list">
        <el-scrollbar class="mobile-scrollbar" tag="div" wrap-class="scrollbar-wrapper">
          <div class="mobile-product-scroll">
            <div
                class="mobile-product-item"
                :class="{ active: activeProduct === 'all' }"
                @click="getListAll"
            >
              <el-image
                  class="mobile-menu-item-image"
                  :src="require('@/assets/aa/xm.png')"
                  fit="cover"
              ></el-image>
              <span class="mobile-product-name">全部案例</span>
            </div>

            <div
                v-for="product in leftProducts"
                :key="product.id"
                class="mobile-product-item"
                :class="{ active: activeProduct === product.id }"
                @click="handleProductSelect(product.id)"
            >
              <el-image
                  class="mobile-menu-item-image"
                  :src="getFirstImage(product.imgUrl)"
                  fit="cover"
                  :alt="product.name"
              ></el-image>
              <span class="mobile-product-name">{{ product.name }}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <div class="mobile-products-display">
        <h2 class="mobile-section-title">{{ currentProductNameA || '全部案例' }} 相关案例</h2>
        <div v-if="loading" class="loading-container">
          <el-skeleton :rows="4" animated />
        </div>
        <div v-else class="mobile-products-grid">
          <div
              v-for="product in paginatedProducts"
              :key="product.id"
              class="mobile-product-card"
          >
            <h3 class="mobile-product-name">{{ product.name }}</h3>
            <el-image
                class="mobile-product-image"
                :src="getFirstImage(product.imgUrl)"
                fit="cover"
                :alt="product.name"
            ></el-image>
            <div class="mobile-product-description">
              <p>{{ product.description }}</p>
            </div>
            <el-button
                type="primary"
                size="small"
                class="mobile-learn-more-btn"
                @click="goToProductDetail(product.id)"
            >
              了解更多
            </el-button>
          </div>
        </div>

        <!-- 无数据提示 -->
        <div v-if="!loading && paginatedProducts.length === 0" class="no-data mobile-no-data">
          暂无相关案例
        </div>

        <!-- 移动端分页 -->
        <el-pagination
            v-if="totalProducts > pageSize"
            class="mobile-pagination"
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            small
            :pager-count="5"
            layout="prev, pager, next"
            :total="totalProducts"
            prev-text="<"
            next-text=">"
            :hide-on-single-page="true">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import server from "@/api/server";

export default {
  name: 'CaseShow',
  data() {
    return {
      activeProduct: 'all',
      windowWidth: 0,
      leftProducts: [],
      allProducts: [],
      currentProductNameA: '全部案例',
      currentPage: 1,
      pageSize: 4,
      loading: true
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.allProducts.slice(start, end);
    },
    totalProducts() {
      return this.allProducts.length;
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
    this.initData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  created() {
    this.handleRouteParams();
  },
  // 添加路由监听
  watch: {
    '$route'(to, from) {
      // 当路由变化时，特别是查询参数变化时，重新处理
      if (to.name === 'CaseShow') {
        this.handleRouteParams();
      }
    }
  },
  methods: {
    async initData() {
      try {
        const res = await server.getCase();
        this.leftProducts = res.data.data || [];
      } catch (error) {
        console.error('获取案例分类失败:', error);
        this.leftProducts = [];
      }
    },

    handleRouteParams() {
      const id = this.$route.query.id;
      if (id && !['null', 'undefined', ''].includes(String(id))) {
        this.handleProductSelect(id);
      } else {
        this.getListAll();
      }
    },

    getFirstImage(imgUrls) {
      if (!imgUrls) return '';
      const urls = imgUrls.split(',');
      return urls[0].trim();
    },

    async getAllProductsByClassId(productClassId) {
      this.loading = true;
      try {
        const res = await server.getCaseListByClassId(productClassId);
        this.allProducts = res.data.data || [];
        this.currentPage = 1;
        const product = this.leftProducts.find(item => item.id == productClassId);
        this.currentProductNameA = product ? product.name : '全部案例';
        this.activeProduct = productClassId;
      } catch (error) {
        console.error('获取案例列表失败:', error);
        this.allProducts = [];
        this.currentProductNameA = '全部案例';
      } finally {
        this.loading = false;
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    handleProductSelect(index) {
      if (index === 'all') {
        this.getListAll();
      } else {
        this.getAllProductsByClassId(index);
      }
      this.updateRoute(index);
    },

    goToProductDetail(id) {
      if (!id || id === 'all') {
        console.warn('无效的案例ID');
        return;
      }

      try {
        this.$router.push({
          path: 'CaseShowContent',
          query: {
            id: id
          }
        }).catch(err => {
          if (err.name === 'NavigationDuplicated') {
            console.warn('重复导航到相同路由');
          } else if (err.name === 'NavigationCancelled') {
            console.warn('导航被取消');
          } else {
            console.error('路由跳转失败:', err);
          }
        });
      } catch (error) {
        console.error('路由跳转异常:', error);
      }
    },

    async getListAll() {
      this.loading = true;
      try {
        const res = await server.getListAll();
        this.allProducts = res.data.data || [];
        this.currentProductNameA = '全部案例';
        this.activeProduct = 'all';
        this.currentPage = 1;
      } catch (error) {
        console.error('获取全部案例失败:', error);
        this.allProducts = [];
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },

    updateRoute(id) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          id: id !== 'all' ? id : undefined
        }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由更新失败:', err);
        }
      });
    }
  }
}
</script>



<style scoped>
/* 基础样式 */
.product-center-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

/* PC端样式 */
.pc-layout .product-list {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  height: 100%;
  transition: all 0.3s ease;
}

.pc-layout .list-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.pc-layout .scrollbar {
  height: calc(100% - 50px);
}

.pc-layout .product-menu {
  border-right: none;
}

.pc-layout .product-item {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #f5f5f5;
  transition: all 0.2s;
}

.pc-layout .product-item:hover {
  background-color: #f8fafc;
}

.pc-layout .product-item:last-child {
  border-bottom: none;
}

.pc-layout .menu-item-content {
  display: flex;
  align-items: center;
}

.pc-layout .product-name {
  font-size: 15px;
  font-weight: 500;
  color: #444;
}

.pc-layout .products-display {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  min-height: 600px;
}

.pc-layout .section-title {
  font-size: 22px;
  color: #333;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 600;
}

.pc-layout .product-col {
  margin-bottom: 30px;
}

.pc-layout .product-card {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #eee;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.pc-layout .product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: transparent;
}

.pc-layout .product-name {
  font-size: 17px;
  color: #333;
  margin: 15px 0;
  font-weight: 600;
  line-height: 1.4;
}

.pc-layout .product-image {
  width: 100%;
  height: 220px;
  margin-bottom: 15px;
  border-radius: 8px;
  object-fit: cover;
  transition: transform 0.3s;
}

.pc-layout .product-card:hover .product-image {
  transform: scale(1.02);
}

.pc-layout .learn-more-btn {
  width: 100%;
  padding: 12px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 6px;
  margin-top: auto;
  background: linear-gradient(90deg, #409EFF, #64b5ff);
  border: none;
}

/* 移动端样式 */
.mobile-layout {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.mobile-product-list {
  background: #fff;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 15px;
}

.mobile-scrollbar {
  height: 120px;
}

.mobile-product-scroll {
  display: flex;
  padding-bottom: 15px;
}

.mobile-product-item {
  flex: 0 0 90px;
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 8px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  background: #f9f9f9;
}

.mobile-product-item.active {
  background-color: #e6f2ff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.mobile-product-item:active {
  transform: scale(0.96);
}

.mobile-menu-item-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  margin-bottom: 8px;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.mobile-product-name {
  font-size: 12px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #444;
  font-weight: 500;
}

.mobile-products-display {
  background: #fff;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.mobile-section-title {
  font-size: 17px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.mobile-product-card {
  background: #fff;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #eee;
  transition: all 0.2s;
}

.mobile-product-card:active {
  transform: scale(0.98);
}

.mobile-product-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.mobile-product-image {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  margin-bottom: 10px;
  object-fit: cover;
}

.mobile-product-description {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mobile-learn-more-btn {
  width: 100%;
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  background: linear-gradient(90deg, #409EFF, #64b5ff);
  border: none;
}

/* 分页样式 */
.pagination {
  margin-top: 30px;
  text-align: center;
}

.pagination >>> .el-pagination.is-background .btn-prev,
.pagination >>> .el-pagination.is-background .btn-next,
.pagination >>> .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin: 0 4px;
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  transition: all 0.3s;
}

.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409EFF;
  color: #fff;
  border-color: #409EFF;
}

.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #409EFF;
  border-color: #409EFF;
}

.pagination >>> .el-pagination__jump {
  margin-left: 10px;
}

.pagination >>> .el-pagination__editor {
  width: 50px;
}

.mobile-pagination {
  margin-top: 20px;
  justify-content: center;
}

.mobile-pagination >>> .el-pagination.is-background .btn-prev,
.mobile-pagination >>> .el-pagination.is-background .btn-next,
.mobile-pagination >>> .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin: 0 2px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
}

.mobile-pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409EFF;
  color: #fff;
  border-color: #409EFF;
}

.mobile-pagination >>> .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #409EFF;
  border-color: #409EFF;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .mobile-products-grid {
    grid-template-columns: 1fr;
  }

  .mobile-product-image {
    height: 150px;
  }

  .mobile-product-list {
    padding: 12px;
  }

  .mobile-product-item {
    flex: 0 0 80px;
    margin-right: 10px;
  }

  .mobile-pagination >>> .el-pager li {
    min-width: 24px;
    height: 24px;
    line-height: 24px;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.product-card, .mobile-product-card {
  animation: fadeIn 0.4s ease-out forwards;
}

.product-card:nth-child(1), .mobile-product-card:nth-child(1) { animation-delay: 0.1s; }
.product-card:nth-child(2), .mobile-product-card:nth-child(2) { animation-delay: 0.2s; }
.product-card:nth-child(3), .mobile-product-card:nth-child(3) { animation-delay: 0.3s; }
.product-card:nth-child(4), .mobile-product-card:nth-child(4) { animation-delay: 0.4s; }

/* 新增样式 */
.loading-container {
  padding: 30px 0;
  text-align: center;
}

.no-data {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 16px;
}

.mobile-no-data {
  padding: 20px 0;
  font-size: 14px;
}
</style>
